import { useState, type ReactNode } from "react";

interface CollapsibleBodyProps {
  /** Cantidad de elementos que se van a mostrar dentro del cuerpo. */
  count: number;
  /** A partir de cuántos elementos se ofrece plegar/desplegar. */
  threshold?: number;
  /** Texto del contador (ej. "productos", "meses"). */
  unit?: string;
  /** Estado inicial: por defecto arranca plegado cuando la lista es larga. */
  defaultOpen?: boolean;
  children: ReactNode;
}

// Cuerpo plegable para secciones largas: mantiene la tarjeta compacta y deja
// desplegar el detalle a demanda. Si el contenido es corto, se muestra siempre
// y no se ofrece el botón, para no recargar la pantalla.
const CollapsibleBody = ({
  count,
  threshold = 6,
  unit = "elementos",
  defaultOpen = false,
  children,
}: CollapsibleBodyProps) => {
  const [open, setOpen] = useState(defaultOpen);

  if (count <= threshold) return <>{children}</>;

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-2 rounded-md bg-background-200/40 border border-background-300/40 px-3 py-2 text-[11px] font-semibold text-foreground-700 hover:border-accent-500/40 hover:text-foreground-900 cursor-pointer transition-colors"
      >
        <span className="flex items-center gap-1.5 whitespace-nowrap">
          <i className="ri-list-check-2 text-accent-300" />
          {open ? "Ocultar detalle" : "Ver detalle"}
          <span className="text-foreground-500 font-normal">
            · {count} {unit}
          </span>
        </span>
        <i
          className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-base text-accent-300`}
        />
      </button>
      {open && <div className="mt-3 animate-fade-up">{children}</div>}
    </div>
  );
};

export default CollapsibleBody;